import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

export interface PaymentSlice {
  method: string;
  percentage: number;
  amount: number;
}

interface PaymentSplitProps {
  data: PaymentSlice[];
}

const COLORS = [
  'oklch(var(--primary-400))',
  'oklch(var(--secondary-400))',
  'oklch(var(--background-500))',
  'oklch(var(--accent-300))',
  'oklch(var(--background-400))',
];

export default function PaymentSplit({ data }: PaymentSplitProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <h4 className="text-sm font-semibold text-foreground-800 mb-3">Payment Split</h4>
      {data.length === 0 ? (
        <div className="h-32 flex flex-col items-center justify-center gap-2 text-center">
          <i className="ri-bank-card-line text-2xl text-foreground-300"></i>
          <p className="text-sm text-foreground-400">No payments yet today</p>
        </div>
      ) : (
        <div className="flex items-center gap-4">
          <div className="w-32 h-32 shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={32}
                  outerRadius={56}
                  paddingAngle={2}
                  dataKey="percentage"
                  strokeWidth={0}
                >
                  {data.map((_, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: 'oklch(var(--background-50))',
                    border: '1px solid oklch(var(--background-200))',
                    borderRadius: '8px',
                    fontSize: '12px',
                  }}
                  formatter={(value: number) => [`${value}%`, '']}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-2">
            {data.map((item, i) => (
              <div key={item.method} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div
                    className="w-2.5 h-2.5 rounded-sm"
                    style={{ backgroundColor: COLORS[i % COLORS.length] }}
                  ></div>
                  <span className="text-xs text-foreground-600">{item.method}</span>
                </div>
                <span className="text-xs font-medium text-foreground-800">{item.percentage}%</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
